import React from 'react';
import useGame from '@monorepo/shared/src/hooks/use-game';
import isLastPage from '@monorepo/shared/src/util/is-last-page-util';
import SoundOutWordsProvider from 'state/providers/SoundOutWordsProvider';
import ActivityLastPage from './ActivityLastPage';
import ActivityPage from './ActivityPage';
import makeStyles from '@mui/styles/makeStyles';
import { maybe } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { Paper } from '@mui/material';

const SoundOutWordsContainer: React.FC = () => {
  const classes = useStyles();
  const [gameState] = useGame();

  const shouldRenderLastPage = isLastPage(gameState);

  const MaybeActivityPage = maybe(ActivityPage);
  const MaybeActivityLastPage = maybe(ActivityLastPage);

  return (
    <SoundOutWordsProvider>
      <Paper className={classes.container} elevation={3}>
        <MaybeActivityPage shouldRender={!shouldRenderLastPage} />
        <MaybeActivityLastPage shouldRender={shouldRenderLastPage} />
      </Paper>
    </SoundOutWordsProvider>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default SoundOutWordsContainer;
